var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.products.length > 0
      ? _c(
          "div",
          {
            staticClass:
              "position-absolute d-flex justify-content-center align-items-center comparecounter",
          },
          [_c("span", [_vm._v(_vm._s(_vm.products.length))])]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "container-popup" }, [
      _c(
        "div",
        {
          class: {
            compareProducts: true,
            "d-flex": this.open,
            hoverable: this.hoverable,
          },
        },
        [
          _vm.products.length == 0
            ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.t("compare.emptylist")))])])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(this.products, function (item) {
              return _c(
                "li",
                { attrs: { "data-sku:": "item.data.product.shopProductId" } },
                [
                  _c("div", { staticClass: "product-image-container" }, [
                    _c("img", {
                      staticClass: "product-image",
                      attrs: {
                        src: item.data.product.medias[0].path,
                        alt: item.data.product.title,
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "product-center" }, [
                    _c("h4", [_vm._v(_vm._s(item.data.product.title))]),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "deleteComparisonButton",
                    on: {
                      click: function ($event) {
                        return _vm.deleteItem(item.data.product.shopProductId)
                      },
                    },
                  }),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              class: [{ inactive: this.products.length < 2 }],
              attrs: { href: _vm.url },
            },
            [_vm._v(_vm._s(_vm.t("compare.button")))]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }